/* components/patterns/EntityEditor.jsx — хром drawer-редактора (внутри Drawer-тела).
   Drawer-шром (шапка/крошки/закрытие) даёт DrawerStackRenderer; ЗДЕСЬ — тело:
   панель заголовка (title-поле + статус + действия), вкладки, скролл-контент,
   sticky-нижняя панель действий (Отмена/Сохранить). Интеграция UnsavedChanges:
   редактор регистрирует dirty через useUnsavedGuard(key, dirty).
   Пропсы: titleField, status, kindBadge, headActions, tabs, activeTab, onTab,
           children, footer, dirtyKey, dirty.
   ХЕНДОФФ → frontend/src/components/common/EntityEditor.jsx. */

import React from 'react';
import { useUnsavedGuard } from '../../app/providers/UnsavedChangesProvider.jsx';
import { Tabs } from './Tabs.jsx';

  const { useRef, useLayoutEffect, useEffect } = React;

  /* EntityTitleInput — заголовок-редактор сущности: авто-растущий textarea, переносит
     длинные названия на 2+ строки (input их обрезал). Выглядит как крупный заголовок. */
  function EntityTitleInput({ value, onChange, placeholder, invalid, ariaLabel }) {
    const ref = useRef(null);
    const resize = () => { const el = ref.current; if (!el) return; el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; };
    useLayoutEffect(() => { resize(); }, [value]);
    // пересчёт высоты при изменении ширины (drawer-анимация / смена брейкпоинта) — иначе длинный заголовок обрезался
    useEffect(() => {
      resize();
      const el = ref.current;
      if (!el || typeof ResizeObserver === 'undefined') return;
      const ro = new ResizeObserver(() => resize());
      ro.observe(el);
      return () => ro.disconnect();
    }, []);
    return (
      <textarea ref={ref} className="ttk-title-input" rows={1} value={value || ''} placeholder={placeholder}
        aria-label={ariaLabel} aria-invalid={invalid || undefined}
        onChange={(e) => { onChange && onChange(e); resize(); }} />
    );
  }

  function EntityEditor({ titleField, status, kindBadge, headActions, tabs, activeTab, onTab,
                          children, footer, dirtyKey, dirty }) {
    useUnsavedGuard(dirtyKey || 'entity-editor', !!dirty);
    return (
      <div className="entity-editor">
        <div className="entity-editor__top">
          <div className="entity-editor__title-row">
            <div className="entity-editor__title grow">{titleField}</div>
            {(kindBadge || status) && (
              <div className="entity-editor__meta">
                {kindBadge}{status}
              </div>
            )}
            {headActions && <div className="entity-editor__head-actions">{headActions}</div>}
          </div>
        </div>
        {tabs && tabs.length > 0 && (
          <div className="entity-editor__tabs">
            <Tabs items={tabs} value={activeTab} onChange={onTab} variant="line" />
          </div>
        )}
        <div className="entity-editor__content">{children}</div>
        {footer && <div className="entity-editor__foot">{footer}</div>}
      </div>
    );
  }

export { EntityEditor };
export { EntityTitleInput };
